import { ComponentProps } from "react";
import { Option, ProfessionFilterModalInnerProps } from "../../../utils";
import { SingleSelect } from "@bonliva-crm/ui";
import locale from "@bonliva-crm/locale";
import { isFilterSelected } from "../../../../../utils/is-filter-selected";

const optInterested = [
  { label: locale.Interested, value: true.toString() },
  { label: locale.NotInterested, value: false.toString() }
];

const optExperienced = [
  { label: locale.IsExperienced, value: true.toString() },
  { label: locale.IsNotExperienced, value: false.toString() }
];

export const ExperienceAndJobofferFilter = (props: ProfessionFilterModalInnerProps) => {
  const singleSelectIsExperiencedProps: ComponentProps<typeof SingleSelect<Option>> = {
    options: optExperienced,
    value: props?.value?.experienced
      ? optExperienced.find((x) => x.value === props?.value?.experienced) ?? null
      : null,
    placeholder: null,
    inputLabel: locale.IsExperienced,
    onChange: (selected) => {
      props.onChange({
        ...props?.value,
        experienced: selected?.value
      });
    },
    hideSelectedOptions: false,
    controlShouldRenderValue: true,
    closeMenuOnSelect: true,
    isSearchable: false,
    isClearable: isFilterSelected(props?.value?.experienced),
    onClear: () => {
      props.onChange({
        ...props?.value,
        experienced: null
      });
    },
    maxMenuHeight: 600,
    optionType: "radio",
    menuPlacement: "bottom" as const,
    // showBadge: isFilterSelected(props?.value?.experienced),
    styleProps: { menu: { showBorder: true } }
  };

  const singleSelectWantJobOfferProps: ComponentProps<typeof SingleSelect<Option>> = {
    options: optInterested,
    value: props?.value?.interested
      ? optInterested.find((x) => x.value === props?.value?.interested) ?? null
      : null,
    inputLabel: locale.Interested,
    placeholder: null,
    onChange: (selected) => {
      props.onChange({
        ...props?.value,
        interested: selected?.value
      });
    },
    hideSelectedOptions: false,
    controlShouldRenderValue: true,
    closeMenuOnSelect: true,
    isSearchable: false,
    isClearable: isFilterSelected(props?.value?.interested),
    onClear: () => {
      props.onChange({
        ...props?.value,
        interested: null
      });
    },
    maxMenuHeight: 600,
    optionType: "radio",
    menuPlacement: "auto",
    // showBadge: isFilterSelected(props?.value?.interested),
    styleProps: { menu: { showBorder: true } }
  };

  return (
    <>
      <SingleSelect<Option> {...singleSelectIsExperiencedProps} />
      <SingleSelect<Option> {...singleSelectWantJobOfferProps} />
    </>
  );
};
